import _get from 'lodash/get';
import _map from 'lodash/map';


import initialState from './initialState';
import actionType from './actionTypes';

const viewConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_VIEW_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                viewConfigurations: action.payload,
                viewNamesForSelectionBox: _map(action.payload, (data) => ({
                    ...data,
                    label: data.view_name,
                    value: data.view_name,
                })),
            };
        }
        case actionType.SET_DYNAMIC_VIEW_CONFIGURATION_SUCCESS:
            const viewDataDictionary = _get(action.payload, 'view_settings.viewDataDictionary', []);
            const queryJson = _get(action.payload, 'view_settings.queryJson', []);
            const fieldOptions = _get(action.payload, 'view_settings.fieldOptions', '');
            const formSourceFields = _get(action.payload, 'view_settings.formSourceFields', []);
            const sources = _get(action.payload, 'view_settings.sources', []);
            return {
                ...state,
                viewSettings: {
                    ...state.viewSettings,
                    viewDataDictionary,
                    queryJson,
                    fieldOptions,
                    formSourceFields,
                    sources,
                    formPropsUpdated: viewDataDictionary.length > 0,
                },
            };
        default:
            return state;
    }
};

export default viewConfigurationReducer;